module.exports = __webpack_public_path__ + "static/media/preview.688bdfbb.png";